import { CustomError } from '@tencent/memoire-error-utils';
export var UnexpectedModifierError = CustomError.withMessageCreator('UnexpectedModifierError', function (stage) {
    return "unexpected error occurred at the \"" + stage + "\" stage of the plugable function, " +
        'there may be a bug in your modifiers.';
});
export var InvalidPatchedFunctionError = CustomError.withMessageCreator('InvalidPatchedFunctionError', function (key) { return "patched target is not a function, patched key is \"" + key + "\""; });
//# sourceMappingURL=errors.js.map